export default {"src":"/_next/static/media/cat-champion.b6bfe034.svg","height":812,"width":900};